import LessonSelectionActionBar from './LessonSelectionActionBar';
import LessonsHeader from './LessonsHeader';
import LessonsList from './LessonsList';
import { Box, Flex, Separator } from '@chakra-ui/react';
import { LessonWithClient } from './LessonsController';
import { useSelectedLessonRoute } from './useSelectedLessonRoute';
import { useState } from 'react';
export type LessonsViewProps = {
	lessons: LessonWithClient[];
}

function LessonsView({ lessons }: LessonsViewProps) {
	const [filteredLessons, setFilteredLessons] = useState(lessons as LessonWithClient[]);
	const { selectedLessonId, setSelectedLessonId, toggleSelectedLessonId } = useSelectedLessonRoute();
	const selectedLesson = lessons.find((lesson) => lesson.id === selectedLessonId) ?? null;

	return (
        <Flex direction="column" height="100%" minH={0}>
			<LessonsHeader
				lessons={lessons}
				onFilter={setFilteredLessons}
			/>
			<Separator />
			<Box flex={1} minH={0} overflowY="auto">
				<LessonsList lessons={filteredLessons} selectedLessonId={selectedLessonId} onSelectLesson={toggleSelectedLessonId} />
			</Box>
			<LessonSelectionActionBar lesson={selectedLesson} onClearSelection={() => setSelectedLessonId(null)} />
        </Flex>
    );
}

export default LessonsView;
